import { render, staticRenderFns } from "./grid-title-textarea.vue?vue&type=template&id=e0396c72&scoped=true"
import script from "./grid-title-textarea.vue?vue&type=script&lang=js"
export * from "./grid-title-textarea.vue?vue&type=script&lang=js"
import style0 from "./grid-title-textarea.vue?vue&type=style&index=0&id=e0396c72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0396c72",
  null
  
)

export default component.exports